import {ServiceResponse} from "./serviceResponse";
import {ProductIdConstants} from './productIdConstants';
import {CatalogEntryIdConstants} from './catalogEntryIdConstants';
import {SchedulingWindow} from "app/scheduling-windows/models/scheduling-window";
import {AccountRoute} from "../_components/login/login";
import {AppointmentConfigs} from "./AppointmentsConfig";

export class ApplicationConstantsResponse implements ServiceResponse {
    productIds: ProductIdConstants;
    catalogEntryIds: CatalogEntryIdConstants;
    clientEnvironment: string;
    preauthLimit: number;
    preauthEnabled: boolean;
    preauthFleet: boolean;
    awsRegionUrl: string = '';
    fleetFeatures: boolean = true;
    zipLength: number = 5;
    paymentInTheBookingFlow: boolean = true;
    vinRequired: boolean = true;
    responseCode: number;
    message: string;
    detail: string;
    reason: ServiceResponse;
    fetchDate: string;
    allowProviderSelection: boolean;
    supportedCountries?: string[];
    autoLogout: boolean;
    schedulingWindows: SchedulingWindow[];
    fetchVehicleServiceIntervals: boolean = true;
    mileageInBookingFlow?: boolean;
    userSsoEnabled?: boolean;
    accountRoutes: AccountRoute[];
    ymLoginMessagingRedirect: boolean;
    awsS3BucketURL?: string;
    appEnv?: string;
    photosS3Bucket?: string;
    uploadsS3Bucket?: string;
    attachmentsS3Bucket?: string;
    templatesS3Bucket?: string;
    mobileTyreReplacementConfigs?: {
        tireProductId?: number;
        tirePartNameId?: number;
        tirePartPositionId?: number;
    };
    appointmentConfigs?: AppointmentConfigs;
    jobConfig: {
        appointmentChangesByCustomer: boolean;
        bookingFlowAddons: boolean;
        cancellationJobFeeInAdmin: boolean;
        bookingFlowLocationType: boolean;
        bookingFlowLocationDetails: boolean;
        bookingFlowKeyHandOff: boolean;
        bookingSlots: boolean;
        bookingSlotDuration: number;
        showCustomerPurchaseOrder: boolean;
    };
    allowCustomService: boolean;
    pricingConfig: {
        cancellationFee: number;
        earlyCancellationFee: number;
        isSurchargeEnabled: boolean;
    };
    s3BucketRegion: string;
    enableSetNewPasswordRequired: boolean;
}
